import { DefaultValues } from "react-hook-form"
import { ChEditBillingSchemaType } from "@/modules/common/billing/components/billing-form/ch/edit/schema/ch-edit-billing-schema"
import {
  DEFAULT_NOT_BILLABLE_REASON,
  EMPLOYER_INSURANCE,
} from "@/modules/common/billing/components/billing-form/constants"
import { Law, NotBillableReason, TreatmentReason } from "@/types/__generated__/union-types"

type BillingAttribute = {
  readonly treatmentReason: TreatmentReason | null
  readonly accidentReference: string | null
  readonly dateOfAccident: string | null
  readonly isEmployer: boolean | null
  readonly notBillableReason: NotBillableReason | null
  readonly organisationId: string | null
  readonly reason: string | null
  readonly lawType: Law | null
  readonly ivgCaseReference: string | null
  readonly mvgCaseReference: string | null
}

export const getChEditExistingBillingData = (
  billingAttribute: BillingAttribute | null,
): DefaultValues<ChEditBillingSchemaType> | null =>
  billingAttribute
    ? {
        ...billingAttribute,
        reason: billingAttribute.reason ?? undefined,
        treatmentReason: billingAttribute.treatmentReason ?? undefined,
        notBillableReason: billingAttribute.notBillableReason ?? DEFAULT_NOT_BILLABLE_REASON,
        organisationId: billingAttribute.isEmployer
          ? EMPLOYER_INSURANCE
          : (billingAttribute.organisationId ?? undefined),
        dateOfAccident: billingAttribute.dateOfAccident ? new Date(billingAttribute.dateOfAccident) : undefined,
        accidentReference: billingAttribute.accidentReference ?? undefined,
        lawType: billingAttribute.lawType ?? undefined,
        ivgCaseReference: billingAttribute.ivgCaseReference ?? undefined,
        mvgCaseReference: billingAttribute.mvgCaseReference ?? undefined,
      }
    : null
